import UiConfigChanger from './uiConfigChanger.container';

export default UiConfigChanger;
